import { ActionsUnion, createAction } from 'spw-redux/types';
import { APIToken } from './types';

export const BEGIN_AUTH = 'auth/BEGIN_AUTH';
export const PROCEED_PASSWORD_FLOW = 'auth/PROCEED_PASSWORD_FLOW';
export const RESET_AUTH_FLOW = 'auth/RESET_AUTH_FLOW';

export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCEEDED = 'auth/LOGIN_SUCCEEDED';
export const LOGIN_FAILED = 'auth/LOGIN_FAILED';

export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_SUCCEEDED = 'auth/LOGOUT_SUCCEEDED';

export const SET_USERNAME = 'auth/SET_USERNAME';

export const SET_PASSWD = 'auth/SET_PASSWD';

export const SET_CSFR_TOKEN = 'auth/SET_CSFR_TOKEN';

export const SAVE_API_TOKEN = 'auth/SET_API_TOKEN';
export const SAVE_USER_TOKEN = 'auth/SAVE_USER_TOKEN';

export const LOAD_API_TOKEN = 'auth/LOAD_API_TOKEN';
export const LOAD_API_TOKEN_SUCCEEDED = 'auth/LOAD_API_TOKEN_SUCCEEDED';

export const SET_EMAIL = 'auth/SET_EMAIL';
export const CLEAR_EMAIL = 'auth/CLEAR_EMAIL';

export const SEND_RECOVERY_EMAIL = 'auth/SEND_RECOVERY_EMAIL';
export const SEND_RECOVERY_EMAIL_SUCCESS = 'auth/SEND_RECOVERY_EMAIL_SUCCESS';
export const SEND_RECOVERY_EMAIL_FAILED = 'auth/SEND_RECOVERY_EMAIL_FAILED';

export const SET_NEW_PASSWORD = 'auth/SET_NEW_PASSWORD';

export const SET_VERIFY_PASSWORD = 'auth/SET_VERIFY_PASSWORD';

export const SEND_VERIFY_PASSWORD = 'auth/SEND_VERIFY_PASSWORD';
export const SEND_VERIFY_PASSWORD_SUCCESS = 'auth/SEND_VERIFY_PASSWORD_SUCCESS';
export const SEND_VERIFY_PASSWORD_FAILED = 'auth/SEND_VERIFY_PASSWORD_FAILED';

export const UNSET_UPDATE_PASSWORD_SUCCESS =
  'auth/UNSET_UPDATE_PASSWORD_SUCCESS';

export const SET_AUTH_LOADING = 'auth/SET_AUTH_LOADING';
export const TEST_ERROR = 'auth/TEST_ERROR';

export const beginAuth = (email: string) => createAction(BEGIN_AUTH, { email });

export const proceedPasswordFlow = () => createAction(PROCEED_PASSWORD_FLOW);
export const resetAuthFlow = () => createAction(RESET_AUTH_FLOW);

export const login = (
  username: string,
  password: string,
  blockRedirect?: boolean,
  redirect?: string
) => createAction(LOGIN, { username, password, blockRedirect, redirect });

export const loginSucceeded = (apiToken: APIToken) =>
  createAction(LOGIN_SUCCEEDED, { apiToken });

export const loginFailed = (error: string, remainingLoginAttempts?: number) =>
  createAction(LOGIN_FAILED, {
    error,
    remainingLoginAttempts,
  });

export const logout = () => createAction(LOGOUT);

export const logoutSucceeded = () => createAction(LOGOUT_SUCCEEDED);

export const setUsername = (username: string) =>
  createAction(SET_USERNAME, { username });

export const setPassword = (password: string) =>
  createAction(SET_PASSWD, { password });

export const setCsfrToken = (csfrToken: string) =>
  createAction(SET_CSFR_TOKEN, { csfrToken });

export const saveApiToken = (token: APIToken) =>
  createAction(SAVE_API_TOKEN, { token });

export const saveUserToken = (token: string) =>
  createAction(SAVE_USER_TOKEN, { token });

export const loadApiToken = () => createAction(LOAD_API_TOKEN);

export const loadApiTokenSucceeded = (apiToken: APIToken) =>
  createAction(LOAD_API_TOKEN_SUCCEEDED, { apiToken });

export const setEmail = (email: string) => createAction(SET_EMAIL, { email });
export const clearEmail = () => createAction(CLEAR_EMAIL);

export const sendRecoveryEmail = (params: { email?: string; token?: string }) =>
  createAction(SEND_RECOVERY_EMAIL, params);
export const sendRecoveryEmailSuccess = () =>
  createAction(SEND_RECOVERY_EMAIL_SUCCESS);
export const sendRecoveryEmailFailed = (errorMessage: string) =>
  createAction(SEND_RECOVERY_EMAIL_FAILED, errorMessage);

export const setNewPassword = (newPassword: string) =>
  createAction(SET_NEW_PASSWORD, { newPassword });

export const setVerifyPassword = (verifyPassword: string) =>
  createAction(SET_VERIFY_PASSWORD, { verifyPassword });

export const sendVerifyPassword = (
  token: string,
  newPassword: string,
  verifyPassword: string
) => createAction(SEND_VERIFY_PASSWORD, { token, newPassword, verifyPassword });

export const sendVerifyPasswordSuccess = () =>
  createAction(SEND_VERIFY_PASSWORD_SUCCESS);

export const sendVerifyPasswordFailed = () =>
  createAction(SEND_VERIFY_PASSWORD_FAILED);

export const unsetUpdatePasswordSuccess = () =>
  createAction(UNSET_UPDATE_PASSWORD_SUCCESS);

export const setAuthLoading = (loading: boolean) =>
  createAction(SET_AUTH_LOADING, { loading });

export const testError = () => createAction(TEST_ERROR);

export const actions = {
  beginAuth,
  proceedPasswordFlow,
  resetAuthFlow,
  login,
  loginSucceeded,
  loginFailed,
  setUsername,
  setPassword,
  setCsfrToken,
  logout,
  logoutSucceeded,
  saveApiToken,
  saveUserToken,
  loadApiToken,
  loadApiTokenSucceeded,
  setEmail,
  clearEmail,
  sendRecoveryEmail,
  sendRecoveryEmailFailed,
  sendRecoveryEmailSuccess,
  setNewPassword,
  setVerifyPassword,
  sendVerifyPassword,
  sendVerifyPasswordSuccess,
  sendVerifyPasswordFailed,
  unsetUpdatePasswordSuccess,
  setAuthLoading,
  testError,
};

export type Actions = ActionsUnion<typeof actions>;
